import { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import Datepicker from "react-tailwindcss-datepicker";
import styled from "styled-components";
import moment from "moment";

interface Props {
  name: string;
  control: any;
  disabled?: boolean;
}

const MyDatePicker = ({ name, control, disabled }: Props) => {
  const [min, setMin] = useState<Date | undefined>();
  const [max, setMax] = useState<Date | undefined>();
  const [defaultOpenDate, setDefaultOpenDate] = useState<Date | undefined>();

  useEffect(() => {
    if (name === "dob") {
      const minDate = moment("01-01-1950").toDate();
      const maxDate = moment().subtract(18, "years").toDate();

      setMin(minDate);
      setMax(maxDate);
      setDefaultOpenDate(maxDate); // 👈 open at 18 years ago
    }
  }, [name]);

  return (
    <Div>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const startFrom = field.value ? undefined : defaultOpenDate;
          return (
            <Datepicker
              useRange={false}
              asSingle={true}
              minDate={min}
              maxDate={max}
              startFrom={startFrom} // 👈 opens at 2007
              displayFormat={"MM-DD-YYYY"}
              value={{ startDate: field.value, endDate: field.value }}
              onChange={(date) => field.onChange(date?.startDate || "")}
              disabled={disabled}
            />
          );
        }}
      />
    </Div>
  );
};

export default MyDatePicker;

const Div = styled("div")`
  .text-sm {
    font-size: 0.75rem;
    line-height: 1rem;
    padding-top: 0.34rem;
    padding-bottom: 0.34rem;
    border-radius: 0;
    padding-right: 1.4rem;
    padding-left: 0.4rem;
  }
  .absolute {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }
  .h-5 {
    height: 1rem;
  }
  .w-5 {
    height: 1rem;
  }
`;
